import { TeachersComponent } from './TeachersComponent';

export function TeachersComponentC(
  props: React.ComponentProps<typeof TeachersComponent>,
) {
  return <TeachersComponent {...props} />;
}
